import sliceCreator from '../../index.jsx';
import { UPDATE_POST_ACTIVITY} from '../../../constants/index.jsx';
const _updatePostActivityAction = sliceCreator('UPDATE_POST_ACTIVITY', UPDATE_POST_ACTIVITY, 'put');

const { asyncAction: updatePostActivityAction, reducer, clearData: clearUpdatePostActivityAction } = _updatePostActivityAction;

export default reducer;

export {
    updatePostActivityAction,
    clearUpdatePostActivityAction
}